import _extends from 'babel-runtime/helpers/extends';

/** 常用图片预览创建组件 */
import VuePictureViewer from '@/components/VuePictureViewer/index';
import XrImport from '@/components/XrImport';
import XrImportMixins from '@/components/XrImport/XrImportMixins';
import XrUpgradeDialog from '@/components/XrUpgradeDialog';
import CRMImport from '@/components/CRMImport';
import { mapGetters } from 'vuex';
import cache from '@/utils/cache';

export default {
  name: 'App',
  components: {
    VuePictureViewer: VuePictureViewer,
    XrImport: XrImport,
    CRMImport: CRMImport,
    XrUpgradeDialog: XrUpgradeDialog
  },
  mixins: [XrImportMixins],
  data: function data() {
    return {
      showPreviewImg: false,
      previewIndex: 0,
      previewImgs: [],
      upgradeDialogShow: false
    };
  },

  computed: _extends({}, mapGetters(['activeIndex', 'addRouters', 'userInfo'])),
  watch: {
    $route: function $route(to, from) {
      this.showPreviewImg = false; // 切换页面隐藏图片预览
    },
    addRouters: function addRouters() {
      var _this = this;

      if (this.userInfo && this.userInfo.is_read_notice != 1) {
        setTimeout(function () {
          _this.upgradeDialogShow = true;
        }, 5000);
      }
    }
  },
  mounted: function mounted() {
    this.addBus();
    this.addDocumentVisibilityChange();
    this.setMinHeight();

    //


    //初始化TV 
    TV_Initialize();
    getEvent(T_GetEvent);
  },

  methods: {
    addDocumentVisibilityChange: function addDocumentVisibilityChange() {
      var _this2 = this;

      // 网页当前状态判断
      // hidden,
      var state, visibilityChange;
      if (typeof document.hidden !== 'undefined') {
        // hidden = 'hidden'
        visibilityChange = 'visibilitychange';
        state = 'visibilityState';
      } else if (typeof document.mozHidden !== 'undefined') {
        // hidden = 'mozHidden'
        visibilityChange = 'mozvisibilitychange';
        state = 'mozVisibilityState';
      } else if (typeof document.msHidden !== 'undefined') {
        // hidden = 'msHidden'
        visibilityChange = 'msvisibilitychange';
        state = 'msVisibilityState';
      } else if (typeof document.webkitHidden !== 'undefined') {
        // hidden = 'webkitHidden'
        visibilityChange = 'webkitvisibilitychange';
        state = 'webkitVisibilityState';
      }
      // 添加监听器，在title里显示状态变化
      document.addEventListener(visibilityChange, function () {
        if (document[state] == 'visible') {
          cache.updateAxiosHeaders();
        }
        _this2.$bus.emit('document-visibility', document[state]);
      }, false);
    },
    addBus: function addBus() {
      var self = this;
      this.$bus.on('preview-image-bus', function (data) {
        self.previewIndex = data.index;
        self.previewImgs = data.data;
        self.showPreviewImg = true;
      });
    },
    setMinHeight: function setMinHeight() {
      this.$nextTick(function () {
        var dpr = window.devicePixelRatio || 1;
        var clientWidth = document.body.clientWidth;
        var dom = document.getElementById('app');
        if (dpr !== 1 && clientWidth > 1600) {
          dom.style.minHeight = '800px';
        } else if (dpr === 1 && clientWidth > 1600) {
          dom.style.minWidth = '1650px';
        } else {
          // dom.style.minWidth = '1200px'
          dom.style.minHeight = '605px';
        }
      });
    }
  }
};